import React, { useState } from 'react';

function RecurringTransactions({ token, recurringTransactions, onUpdate }) {
  const [isAdding, setIsAdding] = useState(false);
  const [editingTransaction, setEditingTransaction] = useState(null);
  const [form, setForm] = useState({
    description: '',
    amount: '',
    type: 'debit',
    frequency: 'monthly',
    start_date: '',
    end_date: '',
    category: '', // New category field
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = editingTransaction ? 'PUT' : 'POST';
    const url = '/recurring_transactions';
    const body = editingTransaction ? { ...form, id: editingTransaction.id } : form;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Failed to ${editingTransaction ? 'update' : 'add'} recurring transaction`);
      }

      setForm({
        description: '',
        amount: '',
        type: 'debit',
        frequency: 'monthly',
        start_date: '',
        end_date: '',
        category: '', // Reset category
      });
      setIsAdding(false);
      setEditingTransaction(null);
      onUpdate(); // Trigger a refetch in the parent component
    } catch (error) {
      console.error('Error saving recurring transaction:', error);
    }
  };

  const handleEdit = (transaction) => {
    setEditingTransaction(transaction);
    setForm({
      description: transaction.description,
      amount: transaction.amount,
      type: transaction.type,
      frequency: transaction.frequency,
      start_date: transaction.start_date,
      end_date: transaction.end_date || '',
      category: transaction.category || '', // Populate category
    });
    setIsAdding(true);
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch('/recurring_transactions', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) {
        throw new Error('Failed to delete recurring transaction');
      }
      onUpdate(); // Trigger a refetch in the parent component
    } catch (error) {
      console.error('Error deleting recurring transaction:', error);
    }
  };

  return (
    <div>
      <h2>Recurring Transactions</h2>
      <button onClick={() => setIsAdding(!isAdding)}>
        {isAdding ? 'Cancel' : 'Add New Recurring Transaction'}
      </button>

      {isAdding && (
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="description"
            value={form.description}
            onChange={handleChange}
            placeholder="Description"
            required
          />
          <input
            type="number"
            name="amount"
            value={form.amount}
            onChange={handleChange}
            placeholder="Amount"
            required
          />
          <select name="type" value={form.type} onChange={handleChange}>
            <option value="debit">Debit</option>
            <option value="deposit">Deposit</option>
          </select>
          <select name="frequency" value={form.frequency} onChange={handleChange}>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="bi-weekly">Bi-Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="annually">Annually</option>
          </select>
          <select name="category" value={form.category} onChange={handleChange} required>
            <option value="">Select Category</option>
            <option value="Income">Income</option>
            <option value="Housing">Housing</option>
            <option value="Utilities">Utilities</option>
            <option value="Transportation">Transportation</option>
            <option value="Food">Food</option>
            <option value="Healthcare">Healthcare</option>
            <option value="Entertainment">Entertainment</option>
            <option value="Debt">Debt</option>
            <option value="Savings">Savings</option>
            <option value="Other">Other</option>
          </select>
          <input
            type="date"
            name="start_date"
            value={form.start_date}
            onChange={handleChange}
            required
          />
          <input
            type="date"
            name="end_date"
            value={form.end_date}
            onChange={handleChange}
            placeholder="End Date (optional)"
          />
          <button type="submit">{editingTransaction ? 'Update' : 'Add'} Transaction</button>
        </form>
      )}

      {recurringTransactions.length > 0 ? (
        <ul>
          {recurringTransactions.map(t => (
            <li key={t.id}>
              {t.description} - ${t.amount} ({t.type}) - every {t.frequency} from {t.start_date} {t.end_date ? `to ${t.end_date}` : ''}
              {t.category && ` [${t.category}]`}
              <button onClick={() => handleEdit(t)}>Edit</button>
              <button onClick={() => handleDelete(t.id)}>Delete</button>
            </li>
          ))}
        </ul>
      ) : (
        <p>No recurring transactions found.</p>
      )}
    </div>
  );
}

export default RecurringTransactions;